export default __webpack_public_path__ + "static/favicon-aeb8917aa87faf8d2cf337eb8986ccc8.ico";